import { assignSafe } from '@summit/core';
import { ScheduleStatus } from '../schedule/schedule-status.enum';
import { LogEntryMethod } from './log-entry-method.enum';

export class TenantReconcileProcessParameter {
  entryMethod: LogEntryMethod;
  autoMatchMismatchedDrivers: boolean;
  autoMarkPending: boolean;
  autoCorrectPendingMiles: boolean;
  autoRemoveCircularJumps: boolean; //same day
  createZeroMileReturnsForDayWages: boolean;
  returnsForDayMinimumMiles: number;
  passRerouteOverpayToDriver: boolean;
  createNoDispatchAsDailyLogs: boolean;
  statusToCreateDailyLogsFor: ScheduleStatus[];

  constructor(jsonData?: Partial<TenantReconcileProcessParameter>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      this.statusToCreateDailyLogsFor = jsonData.statusToCreateDailyLogsFor?.map((status) => status) ?? [];
    }
    this.entryMethod ??= LogEntryMethod.Driver;
    this.autoMatchMismatchedDrivers ??= true;
    this.autoMarkPending ??= true;
    this.createZeroMileReturnsForDayWages ??= false;
    this.autoCorrectPendingMiles ??= true;
    this.passRerouteOverpayToDriver ??= false;
    this.autoRemoveCircularJumps ??= false;
    this.statusToCreateDailyLogsFor ??= [];
  }
}
